import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class BlogcategoryService {
    constructor(private httpmanagerService: HttpManagerService) {
    }

    allCategory(): Promise<any> {
        return this.httpmanagerService.HttpGet('blogcategory', "").then(data => {
            if (data) {
                return data.data;
            }
        })
    }
    allBlog(id): Promise<any> {
        return this.httpmanagerService.HttpGet('blog', id).then(function (data) {
          
            return data.data;
        });
    }

    allBlogcategory(): Promise<any> {
        return this.httpmanagerService.HttpGet('blogcategory', "").then(function (data) {
            return data.data;
        });
    }

    iBlogcategory(app): Promise<any> {
        return this.httpmanagerService.HttpPost('blogcategory', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }

    uBlogcategory(id, data): Promise<any> {
        return this.httpmanagerService.HttpPut('blogcategory', JSON.stringify(data), id).then(function (data) {
            return data;
        });
    }
    dBlogcategory(id): Promise<any> {
        return this.httpmanagerService.HttpDelete('blogcategory', id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/blogcategory/blogcategory.service.ts